import { useState, useEffect, useRef } from "react";
import SlideoverModal from "src/components/SlideoverModal";
import { connect } from "react-redux";
import { RootState, useAppDispatch, useAppSelector } from "src/stores";
import axios from "axios";
import {
  CallLogsToastItem,
  addCallLogsToast,
  clearCallLogsToasts,
  selectCallLogsToasts,
} from "src/stores/callLogsToasts/slice";
import { DisconnectedCall } from "./DisconnectedCall";

import { SelectOption } from "src/interfaces";
import { IncomingCall } from "./IncomingCall";
import { OutGoingCall } from "./OutGoingCall";
import { CallAnswered } from "./callAnswered/Answered";
import { IncomingCallModal } from "../IncomingCallModal";
import { fetchUsers } from "src/stores/user";
import {
  customerInfo,
  fetchCallDetail,
  fetchCallDetailSuccess,
  updateCallLog,
} from "src/stores/calllogs";
import {
  selectCustomerInfo,
  fetchCustomerInfoSuccess,
} from "src/stores/calllogs";
import { validCodes, validEvents } from "./constants";
import { CallModalEnhanced } from "./CallModalEnhanced";
import { saveCallActivityLog } from "src/services/callActivityLog.services";
import { apiBaseUrl } from "src/services/http";

const CallsLogsModal = ({
  fetchCustomerInfo,
  fetchData,
  getCallDetail,
  updateCallDetail,
}: {
  fetchCustomerInfo: Function;
  fetchData: Function;
  getCallDetail: Function;
  updateCallDetail: Function;
}) => {
  const dispatch = useAppDispatch();
  const callLogsToasts = useAppSelector(selectCallLogsToasts);
 

  // Send action to API for call tracking
  // const sendActionToAPI = async (actionType: string, sessionId: string) => {
  //   try {
  //     const authToken = (() => {
  //       const root = JSON.parse(localStorage.getItem("persist:root") || "{}");
  //       const authUserData = root?.authUser ? JSON.parse(root.authUser) : null;
  //       return authUserData?.token || authUserData?.access_token || null;
  //     })();

  //     const formData = new FormData();
  //     formData.append("session_id", sessionId);
  //     formData.append("log_text", actionType);

  //     const config: any = {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     };

  //     if (authToken) {
  //       config.headers["Authorization"] = `Bearer ${authToken}`;
  //     }

  //     const response = await axios.post(
  //       "https://mwcrmdev.cyberace.site/backend/millwoods-crm-backend/public/api/save/call-activity/log",
  //       formData,
  //       config,
  //     );

  //     console.log("Call disconnection tracked successfully:", response.data);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error tracking call disconnection:", error);
  //   }
  // };

  // Listen for OneSignal call_queue_reminder events and push to callLogsToasts
  useEffect(() => {
    function handleOneSignalReminder(event) {
      const n = event?.notification;
      const type =
        n?.additionalData?.notification_type ||
        n?.notification?.additionalData?.notification_type;
      if (type === "call_queue_reminder") {
        // Generate a unique id for the toast
        const genId = () => {
          try {
            if (
              typeof crypto !== "undefined" &&
              typeof crypto.randomUUID === "function"
            ) {
              return crypto.randomUUID();
            }
          } catch (e) {}
          return `reminder-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        };
        const payload = {
          id: genId(),
          title: n?.title || n?.notification?.title,
          description: n?.body || n?.notification?.body,
          createdAt: Date.now(),
          meta: { raw: event },
        };
        // Debug log
        if (process.env.NODE_ENV !== "production") {
          console.debug(
            "CallsLogsModal: dispatching addCallLogsToast",
            payload,
            event,
          );
        }
        dispatch(addCallLogsToast(payload));
      }
    }
    if (typeof window !== "undefined" && window.OneSignal) {
      window.OneSignal.Notifications.addEventListener(
        "foregroundWillDisplay",
        handleOneSignalReminder,
      );
    }
    return () => {
      if (typeof window !== "undefined" && window.OneSignal) {
        window.OneSignal.Notifications.removeEventListener(
          "foregroundWillDisplay",
          handleOneSignalReminder,
        );
      }
    };
  }, [dispatch]);

  const [callType, setCallType] = useState<SelectOption | null>(null);
  const [callOutcome, setCallOutcome] = useState<SelectOption | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [callData, setCallData] = useState<any>(null);
  const [showFloatingModal, setShowFloatingModal] = useState(true);
  // State for IncomingCallModal (must be after callLogsToasts is defined)
  const [showIncomingCallModal, setShowIncomingCallModal] = useState(true);
  const [incomingCallNotification, setIncomingCallNotification] =
    useState<any>(null);



  // Show IncomingCallModal when notification_type === 'call_queue_reminder' in callLogsToasts
  // Helper to read notification_type / eventType from different payload shapes
  const getToastNotificationType = (t: any) => {
    console.log(t, " console.log(t); console.log(t); console.log(t);");
    return (
      t?.meta?.raw?.notification?.additionalData?.notification_type ||
      t?.meta?.raw?.notification?.additionalData?.eventType ||
      t?.meta?.raw?.additionalData?.notification_type ||
      t?.meta?.raw?.additionalData?.eventType ||
      t?.meta?.raw?.data?.eventType ||
      t?.meta?.raw?.data?.notification_type ||
      t?.meta?.raw?.notification?.data?.notification_type ||
      t?.meta?.raw?.notification?.data?.eventType ||
      t?.meta?.raw?.notification_type ||
      t?.meta?.raw?.eventType ||
      null
    );
  };

  useEffect(() => {
    if (!callLogsToasts || callLogsToasts.length === 0) {
      setShowIncomingCallModal(false);
      setIncomingCallNotification(null);
      return;
    }

    // Debug: log reduced info
    console.debug(
      "CallsLogsModal: callLogsToasts count:",
      callLogsToasts.length,
    );
    try {
      console.debug(
        "CallsLogsModal: callLogsToasts raw samples:",
        callLogsToasts.map((t) => ({
          id: t.id,
          title: t.title,
          description: t.description,
          keys: Object.keys(t?.meta?.raw || {}),
          notificationKeys: t?.meta?.raw?.notification
            ? Object.keys(t.meta.raw.notification)
            : null,
        })),
      );
    } catch (e) {
      // ignore debug errors
    }

    const reminderIndex = callLogsToasts.findIndex((t) => {
      const type = getToastNotificationType(t);
      return type === "call_queue_reminder";
    });

    if (reminderIndex >= 0) {
      const reminder = callLogsToasts[reminderIndex];

      // For call_queue_reminder, build a consistent notification object
      const notificationType = getToastNotificationType(reminder);
      let notif;

      if (notificationType === "call_queue_reminder") {
        // Normalize reminder toast for call_queue_reminder
        notif = {
          title: reminder?.title || "Call Feedback Reminder",
          body: reminder?.description || "You have pending call feedback",
          additionalData:
            reminder?.meta?.raw?.notification?.additionalData || {},
        };
      } else {
        notif =
          reminder?.meta?.raw?.notification || reminder?.meta?.raw || reminder;
      }

      setIncomingCallNotification(notif);
      setShowIncomingCallModal(true);
    } else {
      setShowIncomingCallModal(false);
      setIncomingCallNotification(null);
    }
  }, [callLogsToasts]);
  // Handlers for IncomingCallModal
  const handleViewCall = () => {
    setShowIncomingCallModal(false);
    setIncomingCallNotification(null);
    // Dispatch global event to open PendingRemarksPanel in Razor layout
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("openPendingRemarks"));
    }
  };
  const handleViewLater = () => {
    setShowIncomingCallModal(false);
    setIncomingCallNotification(null);
  };
  // Render IncomingCallModal if needed
  const renderIncomingCallModal = () => {
    if (!showIncomingCallModal || !incomingCallNotification) return null;
    return (
      <IncomingCallModal
        isOpen={showIncomingCallModal}
        caller={incomingCallNotification.body || ""}
        queue={incomingCallNotification.title || ""}
        priority="high"
        onView={handleViewCall}
        onViewLater={handleViewLater}
      />
    );
  };
  const callDetail = useAppSelector((state) => state.callDetail);
  const customerInfoState = useAppSelector(selectCustomerInfo);

  // Helper to get eventType safely
  const getEventType = (obj: any) => {
    const additionalData = obj?.meta?.raw?.notification?.additionalData;
    return additionalData &&
      typeof additionalData === "object" &&
      "eventType" in additionalData
      ? additionalData.eventType
      : null;
  };

  // Helper to get code safely
  const getCode = (obj: any) =>
    obj?.meta?.raw?.notification?.additionalData?.code ?? null;

  const root = JSON.parse(localStorage.getItem("persist:root") || "{}");
  const authUser = root?.authUser ? JSON.parse(root.authUser) : null;
  const loggedInUserId = authUser?.id;

  const normalize = (s: any) => String(s ?? "").trim();
  const normalizeLower = (s: any) => normalize(s).toLowerCase();

  // Auto-cleanup expired localStorage items (1 hour)
  const cleanupExpiredStorage = () => {
    const oneHourAgo = Date.now() - 60 * 60 * 1000;

    try {
      const activeCallData = localStorage.getItem("activeCall");
      if (activeCallData) {
        const parsed = JSON.parse(activeCallData);
        const createdAt = parsed?.createdAt;
        if (createdAt && createdAt < oneHourAgo) {
          localStorage.removeItem("activeCall");
        }
      }

      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("callDetail_")) {
          const item = localStorage.getItem(key);
          if (item) {
            const parsed = JSON.parse(item);
            const eventTime = parsed?.call?.event_time;
            const eventTimeMs = eventTime
              ? new Date(eventTime).getTime()
              : null;
            if (eventTimeMs && eventTimeMs < oneHourAgo) {
              keysToRemove.push(key);
            }
          }
        }
      }
      keysToRemove.forEach((key) => localStorage.removeItem(key));
    } catch (e) {
      // ignore cleanup errors
    }
  };

  const isCallEvent = (t: CallLogsToastItem) => {
    const eventType = normalizeLower(getEventType(t));
    const code = normalizeLower(getCode(t));
    return (
      validEvents.map((v) => v.toLowerCase()).includes(eventType) &&
      validCodes.map((v) => v.toLowerCase()).includes(code)
    );
  };

  useEffect(() => {
    const saved = localStorage.getItem("activeCall");
    if (saved) {
      const parsed = JSON.parse(saved);
      setCallData(parsed);
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    cleanupExpiredStorage();
  }, []);

  useEffect(() => {
    const events = callLogsToasts?.filter(isCallEvent);
    if (!events || events.length === 0) return;
    const latest = events[0];
    const callId = latest?.id;
    if (!callId) return;
    const storageKey = "activeCall";

    if (loggedInUserId) {
      localStorage.setItem(storageKey, JSON.stringify(latest));
      setCallData(latest);
      setIsOpen(true);
    }
  }, [callLogsToasts, loggedInUserId]);

  const callerInfo = callData?.meta?.raw?.notification?.additionalData;

  const getModalState = () => {
    const et = normalizeLower(callerInfo?.eventType);
    const code = normalizeLower(callerInfo?.code);
    if (et === "call_inbound" && code === "setup") return "incoming";
    if (et === "call_outbound" && code === "setup") return "outbound";
    if (["call_inbound", "call_outbound"].includes(et) && code === "answered")
      return "active";
    return "idle";
  };

  const modalState = getModalState();

  // Set initial showFloatingModal state based on modalState
  useEffect(() => {
    if (modalState === "active") {
      setShowFloatingModal(false);
    }
  }, [modalState]);
  const sendActionToAPI = async (
    actionType: string,
    sessionId: string,
    queryNo?: string
  ) => {
    try {
      console.log("sendActionToAPI started with:", { actionType, sessionId, queryNo });
      
      // Validate sessionId
      if (!sessionId || sessionId.trim() === "") {
        console.error("❌ Cannot send action to API - sessionId is missing or empty");
        return;
      }
      
      const authToken = (() => {
        try {
          const root = JSON.parse(localStorage.getItem("persist:root") || "{}");
          const authUserData = root?.authUser
            ? JSON.parse(root.authUser)
            : null;
          return authUserData?.token || authUserData?.access_token || null;
        } catch (e) {
          console.error("Error getting auth token:", e);
          return null;
        }
      })();

      const formData = new FormData();
      formData.append("session_id", sessionId);
      let logText = actionType;
      if (queryNo) logText += ` #${queryNo}`;
      formData.append("log_text", logText);

      console.log("Sending to API - session_id:", sessionId, "log_text:", logText);

      const config: any = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      if (authToken) {
        config.headers["Authorization"] = `Bearer ${authToken}`;
        console.log("Auth token added to request");
      } else {
        console.log("No auth token available");
      }

      const url = `${apiBaseUrl}/save/call-activity/log`;
      console.log("Making POST request to:", url);

      const response = await axios.post(url, formData, config);

      console.log("Action sent to API successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error sending action to API:", error);
      if (axios.isAxiosError(error)) {
        console.error("Axios error details:", {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
        });
      }
      throw error;
    }
  };
const lastLoggedRef = useRef<{ state?: string; sessionId?: string }>({});

  // Auto-close CallModalEnhanced after 5 seconds when modalState is "idle"
useEffect(() => {
  const sessionId =
    callerInfo?.sessionId || callDetail?.data?.call?.session_id;

  if (!sessionId) return;

  // prevent duplicate logs for same modalState + sessionId
  if (
    lastLoggedRef.current.state === modalState &&
    lastLoggedRef.current.sessionId === sessionId
  ) {
    return;
  }

  if (modalState === "active") {
    lastLoggedRef.current = { state: "active", sessionId };

    console.log("Logging: Call Answered/Picked by Another User", sessionId);
    sendActionToAPI("Call Answered/Picked by Another User", sessionId)
      .then(() => console.log("✅ Call answered log sent"))
      .catch((error) => console.error("❌ Failed to log call answered:", error));

    return; // no timer in active state
  }

  if (modalState === "idle") {
    lastLoggedRef.current = { state: "idle", sessionId };

    console.log("Logging: Call Disconnected by User", sessionId);
    sendActionToAPI("Call Disconnected by User", sessionId)
      .then(() => console.log("✅ Call disconnection logged successfully"))
      .catch((error) =>
        console.error("❌ Failed to log call disconnection:", error),
      );

    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }
}, [modalState, callerInfo?.sessionId, callDetail?.data?.call?.session_id]);

  useEffect(() => {
    if (!callerInfo?.caller || !callerInfo?.sessionId) return;

    const { eventType, code, sessionId } = callerInfo;
    const shouldFetch =
      validEvents
        .map((v) => v.toLowerCase())
        .includes(normalizeLower(eventType)) &&
      validCodes.map((v) => v.toLowerCase()).includes(normalizeLower(code));
    if (!shouldFetch) return;

    const customerCacheKey = `customerInfo_${callerInfo.caller}`;
    const customerCached = localStorage.getItem(customerCacheKey);
    if (customerCached) {
      try {
        const parsed = JSON.parse(customerCached);
        dispatch(fetchCustomerInfoSuccess(parsed));
      } catch (e) {
        fetchCustomerInfo(callerInfo.caller);
      }
    } else {
      fetchCustomerInfo(callerInfo.caller);
    }

    const cacheKey = `callDetail_${sessionId}`;
    const cached = localStorage.getItem(cacheKey);
    const storeHasSameSession =
      callDetail?.data?.call?.session_id === sessionId;

    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (!storeHasSameSession) {
          dispatch(fetchCallDetailSuccess(parsed));
        }
      } catch (e) {
        // ignore corrupted cache and proceed to fetch
      }
      return;
    }

    if (storeHasSameSession) {
      return;
    }

    getCallDetail(sessionId);
  }, [
    callerInfo?.caller,
    callerInfo?.eventType,
    callerInfo?.code,
    callerInfo?.sessionId,
    callDetail?.data?.call?.session_id,
    dispatch,
  ]);

  useEffect(() => {
    const sessionId = callerInfo?.sessionId;
    if (!sessionId) return;
    const data = callDetail?.data;
    const sessionInData = data?.call?.session_id;
    if (sessionInData && sessionInData === sessionId) {
      const cacheKey = `callDetail_${sessionId}`;
      try {
        localStorage.setItem(cacheKey, JSON.stringify(data));
      } catch (e) {
        // storage write failed
      }
    }
  }, [callDetail?.data, callerInfo?.sessionId]);

  useEffect(() => {
    const phone = callerInfo?.caller;
    if (!phone) return;
    const data = customerInfoState?.data;
    if (!data) return;
    const customerCacheKey = `customerInfo_${phone}`;
    try {
      localStorage.setItem(customerCacheKey, JSON.stringify(data));
    } catch (e) {
      // storage write failed
    }
  }, [customerInfoState?.data, callerInfo?.caller]);

  const onClose = () => {
    dispatch(clearCallLogsToasts());
    setIsOpen(false);
    setCallData(null);
    localStorage.removeItem("activeCall");
  };

  useEffect(() => {
    if (callerInfo?.callPickedByAnotherAgent === true) {
      onClose();
    }
  }, [callerInfo]);

  useEffect(() => {
    if (normalizeLower(callerInfo?.code) === "disconnected") {
      const storageKey = "activeCall";
      const caller = callerInfo?.caller;
      const sessionId = callerInfo?.sessionId;

      try {
        localStorage.removeItem(storageKey);

        if (caller) {
          const customerInfoKey = `customerInfo_${caller}`;
          localStorage.removeItem(customerInfoKey);
        }

        if (sessionId) {
          const callDetailKey = `callDetail_${sessionId}`;
          const callRemarksKey = `callRemarks_${sessionId}`;
          localStorage.removeItem(callDetailKey);
          localStorage.removeItem(callRemarksKey);
          localStorage.removeItem("callDisconnected");
        }

        const keysToRemove: string[] = [];

        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);

          if (key) {
            if (
              key.startsWith("callDetail_") ||
              key.startsWith("callRemarks_") ||
              key.startsWith("customerInfo_") ||
              key === "activeCall" ||
              key === "callDisconnected"
            ) {
              keysToRemove.push(key);
            }
          }
        }

        keysToRemove.forEach((key) => localStorage.removeItem(key));
      } catch (err) {
        console.error("Error clearing localStorage keys:", err);
      }
    }
  }, [callerInfo]);

  const slideoverOnClose = () => {
    if (
      ["call_inbound", "call_outbound"].includes(
        normalizeLower(callerInfo?.eventType),
      ) &&
      normalizeLower(callerInfo?.code) === "disconnected"
    ) {
      return;
    }

    // Show floating modal when slideover closes (for outbound state as well)
    setShowFloatingModal(true);
  };

  const handleSlideoverOpen = () => {
    setShowFloatingModal(false);
  };

  const startOutbound = () => {
    if (!callData) return;
    try {
      const copied = JSON.parse(JSON.stringify(callData));
      const ad = copied?.meta?.raw?.notification?.additionalData;
      if (ad) {
        ad.eventType = "call_outbound";
        ad.code = "setup";
      }
      copied.createdAt = Date.now();

      setIsOpen(false);
      setTimeout(() => {
        try {
          localStorage.setItem("activeCall", JSON.stringify(copied));
        } catch (e) {
          // ignore storage errors
        }
        setCallData(copied);
        setIsOpen(true);
      }, 200);
    } catch (e) {
      // ignore JSON errors
    }
  };

  // Handle click on CallModalEnhanced for incoming, outbound, and active calls
  const handleModalClick = () => {
    if (
      modalState === "incoming" ||
      modalState === "outbound" ||
      modalState === "active"
    ) {
      setShowFloatingModal(false);
      setIsOpen(true);
    }
  };

  if (!callData || !loggedInUserId) return <>{renderIncomingCallModal()}</>;

  const callerNumber =
    callerInfo?.caller || callerInfo?.callerNumber || "Unknown";
  const callerName =
    callerInfo?.callerName || callerInfo?.caller || "Unknown caller";

  const renderContent = () => {
    if (
      !validEvents
        .map((v) => v.toLowerCase())
        .includes(normalizeLower(callerInfo?.eventType)) ||
      !validCodes
        .map((v) => v.toLowerCase())
        .includes(normalizeLower(callerInfo?.code))
    ) {
      return null;
    }

    return (
      <div className="space-y-6">
        {normalizeLower(callerInfo?.eventType) === "call_inbound" &&
          normalizeLower(callerInfo?.code) === "setup" && (
            <IncomingCall callerInfo={callerInfo} />
          )}

        {normalizeLower(callerInfo?.eventType) === "call_outbound" &&
          normalizeLower(callerInfo?.code) === "setup" && (
            <OutGoingCall callerInfo={callerInfo} />
          )}

        {["call_inbound", "call_outbound"].includes(
          normalizeLower(callerInfo?.eventType),
        ) &&
          normalizeLower(callerInfo?.code) === "answered" && (
            <CallAnswered
              callerInfo={callerInfo}
              updateCallDetail={updateCallDetail}
            />
          )}
        {["call_inbound", "call_outbound"].includes(
          normalizeLower(callerInfo?.eventType),
        ) &&
          normalizeLower(callerInfo?.code) === "disconnected" && (
            <DisconnectedCall
              callerInfo={callerInfo}
              onClose={() => onClose()}
              callType={callType}
              setCallType={setCallType}
              callOutcome={callOutcome}
              setCallOutcome={setCallOutcome}
              updateCallDetail={updateCallDetail}
            />
          )}
      </div>
    );
  };

  return (
    <>
      {renderIncomingCallModal()}
      {/* Show CallModalEnhanced for incoming, idle, or when SlideoverModal is closed for active/outbound */}
      {(modalState === "incoming" ||
        modalState === "idle" ||
        (modalState === "active" && showFloatingModal)) && (
        <div onClick={modalState === "idle" || modalState === "active" ? handleModalClick : undefined}>
          <CallModalEnhanced
            callerInfo={callData?.meta?.raw?.notification?.additionalData}
            state={modalState}
            onTransitionToOutbound={startOutbound}
            onClose={onClose}
          />
        </div>
      )}

      {/* Show SlideoverModal for incoming, active and outbound calls when floating modal is hidden */}
      {(modalState === "incoming" ||
        modalState === "active" ||
        modalState === "outbound") &&
        !showFloatingModal && (
          <SlideoverModal 

            visible={isOpen}
            onClose={slideoverOnClose}
            backdrop={false}
            hideCloseIcon={false}
            size="lg"
            handleScroll={false}
            className="max-h-screen overflow-y-auto"
            headerItemsCenter="items-center"
          >
            {renderContent()}
          </SlideoverModal>
        )}
    </>
  );
};

const mapState = (state: RootState) => ({
  getCustomerInfo: state.customerInfo,
  users: state.users,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchCustomerInfo: (payload: string | number) =>
    dispatch(customerInfo(payload)),
  fetchData: (payload?: any) => dispatch(fetchUsers(payload)),
  getCallDetail: (payload?: any) => dispatch(fetchCallDetail(payload)),
  updateCallDetail: (sessionId: string, body: any) =>
    dispatch(updateCallLog(sessionId, body)),
});

export default connect(mapState, mapDispatchToProps)(CallsLogsModal);
